<template>
  <busy-area :busy="loading" class="w-full text-left">
    <a
      v-if="!upload.isNew"
      @click.prevent.stop="open(upload.file.contentUrl)"
    >
      {{ upload.file?.originalFileName ?? upload.file?.id }}
    </a>
    <a
      v-else
      :href="getObjectUrl(upload.file)"
      :download="upload.file?.name"
      @click.stop
    >
      {{ upload.file.name }}
    </a>
    <a
      ref="link"
      :href="href ?? '#'"
      :download="upload.file?.originalFileName ?? upload.file?.id"
      class="hidden"
      @click.stop
    >
    </a>
  </busy-area>
</template>

<script lang="ts" setup>
import { useMemoize } from '@vueuse/core';
import {computed, nextTick, ref} from 'vue';
import { useI18n } from 'vue-i18n';
import type { WbFile } from '@/entities/Entities';
import type { FileUpload } from '@/components/utils/upload/fileUpload';
import BusyArea from '../../busy/BusyArea.vue';
import { fetchApiBase } from '@/hooks/fetch';
import { useNotify } from '../../notifications';

interface Props {
  upload: FileUpload<WbFile>;
}

const props = defineProps<Props>();

const getObjectUrl = (file: Blob) => URL.createObjectURL(file);
const loading = ref(false);
const notify = useNotify();
const { t } = useI18n();

const href = ref();
const link = ref();

const getFileUrl = useMemoize(async (url: string) => {
  try {
    loading.value = true;
    const response = await fetchApiBase(url);
    const blob = await response.blob();
    const objectUrl = getObjectUrl(blob);
    return objectUrl;
  } catch (e) {
    notify?.({
      variant: 'error',
      title: t('files.loadError'),
    });
  } finally {
    loading.value = false;
  }
  return null;
});

const open = async (url: string) => {
  const fileUrl = await getFileUrl(url);
  if (!fileUrl) return;
  href.value = fileUrl;
  await nextTick(() => link.value?.click());
  // const w = window.open(fileUrl, '_target');
};
</script>

<style lang="scss" scoped></style>
